/** @module EngineeringChange/AggregateSpecsController */
define([
	"dojo/_base/declare",
	"csi/table/AggregateFrom",
	"./_AggregateSpecsMixin"
], function(declare,AggregateFrom,_AggregateSpecsMixin) {
	return declare([AggregateFrom,_AggregateSpecsMixin], {
	});
});